import React from 'react'

const ArticleHeader = () => {
  return (
    <header id="header" className="ex-header">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h1 className="white">Longer Article Title Should Definitely Go Here</h1>
      </div> {/* end of col */}
    </div> {/* end of row */}
  </div> {/* end of container */}
</header>

  )
}

export default ArticleHeader